import React, { memo } from "react";

import { DetailItemType } from "../types";

import { ItemDate, ItemInfo, ItemAmount } from ".";

const ListItem: React.FC<DetailItemType> = ({ date, year, info, amount }) => {
  return (
    <li
      className="block border-b border-grey-30 p-4 text-base text-grey-200 first:border-t sm:flex sm:items-center sm:py-6"
      data-testid="result-item"
    >
      <ItemDate date={date} year={year} />
      <ItemInfo {...info} />
      <ItemAmount {...amount} />
    </li>
  );
};

export default memo(ListItem);
